import { RootState } from '../../config';
import { IPhysiologicalDataState } from './types';

export const selectPhysiologicalData = (state: RootState): IPhysiologicalDataState => state.physiologicalData;
